import React from "react";
import * as W from "./WarningRedesStyle";
import { FaBullhorn } from "react-icons/fa";

export default function WarningRedes({ onClose }) {
  return (
    <W.WarningOverlay>
      <W.WarningContainer>
        <W.TopAccent />

        <W.Header>
          <W.IconCircle>
            <FaBullhorn />
          </W.IconCircle>
          <W.Badge>Comunicado</W.Badge>
          <W.Title>Comunicado Oficial</W.Title>
          <W.Divider />
        </W.Header>

        <W.Body>
          <W.TextContent>
            <W.Greeting>Prezados clientes,</W.Greeting>

            <p>
              A Golden Brasil informa que alguns de seus perfis oficiais nas
              redes sociais encontram-se temporariamente indisponíveis na
              plataforma Meta.
            </p>

            <p>
              Nossa equipe já está atuando junto aos canais responsáveis para a
              devida análise e regularização da situação. Até que os perfis
              sejam restabelecidos, reforçamos que toda comunicação com a
              empresa deve ser realizada exclusivamente pelos canais oficiais
              de atendimento já utilizados por nossos clientes.
            </p>

            <p>
              Também informamos que a Golden Brasil segue conduzindo seu
              processo interno de auditoria e conferência contratual, iniciado
              com o objetivo de revisar informações, pagamentos e procedimentos
              administrativos, mantendo o compromisso com a transparência, a
              segurança e a responsabilidade em cada etapa.
            </p>

            <p>
              Durante esse período, pedimos que nossos clientes desconsiderem
              qualquer perfil, página ou contato não confirmado pela empresa.
            </p>

            <p>
              Novas atualizações serão comunicadas diretamente por nossos canais
              oficiais.
            </p>

            <W.Signature>
              Atenciosamente,
              <strong>Golden Brasil</strong>
            </W.Signature>
          </W.TextContent>
        </W.Body>

        <W.Footer>
          <W.AcceptButton onClick={onClose}>Estou ciente</W.AcceptButton>
        </W.Footer>
      </W.WarningContainer>
    </W.WarningOverlay>
  );
}
